import CustomersAttachments from './CustomersAttachments';

export default CustomersAttachments;
